var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUProject(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#1B1F27",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7159 8.5H8.2841C7.8475 8.5 7.5 8.05 7.5 7.5C7.5 6.95 7.85641 6.5 8.2841 6.5H19.7159C20.1525 6.5 20.5 6.95 20.5 7.5C20.5 8.05 20.1525 8.5 19.7159 8.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7159 17.5H8.2841C7.8475 17.5 7.5 17.05 7.5 16.5C7.5 15.95 7.85641 15.5 8.2841 15.5H19.7159C20.1525 15.5 20.5 15.95 20.5 16.5C20.5 17.05 20.1525 17.5 19.7159 17.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7159 13H8.2841C7.8475 13 7.5 12.55 7.5 12C7.5 11.45 7.85641 11 8.2841 11H19.7159C20.1525 11 20.5 11.45 20.5 12C20.5 12.55 20.1525 13 19.7159 13Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 8.5C5.05228 8.5 5.5 8.05228 5.5 7.5C5.5 6.94772 5.05228 6.5 4.5 6.5C3.94772 6.5 3.5 6.94772 3.5 7.5C3.5 8.05228 3.94772 8.5 4.5 8.5Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 13C5.05228 13 5.5 12.5523 5.5 12C5.5 11.4477 5.05228 11 4.5 11C3.94772 11 3.5 11.4477 3.5 12C3.5 12.5523 3.94772 13 4.5 13Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 17.5C5.05228 17.5 5.5 17.0523 5.5 16.5C5.5 15.9477 5.05228 15.5 4.5 15.5C3.94772 15.5 3.5 15.9477 3.5 16.5C3.5 17.0523 3.94772 17.5 4.5 17.5Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUProject);
export default __webpack_public_path__ + "static/media/u_project.7b746c59.svg";
export { ForwardRef as ReactComponent };